export default __webpack_public_path__ + "static/media/next-insights.41933b03.svg";